module.exports = __webpack_public_path__ + "static/media/logoiut.cd08e58c.webp";